<template>
  <div id="organisation-overview">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-8">
            <div class="card overview-card">
              <div class="card-header header-elements-inline" style="padding-bottom:0px;">
                <h5 class="card-title">{{ $t("organisation.overview.title") }}</h5>

                <div class="header-elements">
                  <el-button round size="mini" class="create-event-button" icon="fas fa-plus" @click="createDialog = !createDialog">{{ $t("organisation.overview.createEvent") }}</el-button>
                </div>
              </div>

              <div class="card-body">
                <div class="organisation-header">
                  <div class="organisation-image" :style="'background-image: url(' + $imageus + currentOrganization.image + '?width=200&height=200)'"></div>
                  <div class="organisation-title">
                    <span>{{ $t("organisation.overview.welcome") }}</span>
                    <p>{{ currentOrganization.title }}</p>
                  </div>
                </div>

                <div class="custom-info-card" v-if="!currentOrganization.isApproved">
                  <div class="custom-info-card-icon">
                    <i class="fa fa-exclamation-triangle" alt="" style="color: #FF7511"></i>
                  </div>
                  <div class="custom-info-card-body">
                    <h6>{{ $t("organisation.overview.underReview") }}</h6>
                    <p>{{ $t("organisation.overview.underReviewMsg") }}</p>
                  </div>
                </div>

                <div class="custom-info-card" v-else>
                  <div class="custom-info-card-icon">
                    <i class="fa fa-check" alt="" style="color: #268EA6"></i>
                  </div>
                  <div class="custom-info-card-body">
                    <h6>{{ $t("organisation.overview.accountConfirm") }}</h6>
                    <p>{{ $t("organisation.overview.accountConfirmMsg") }}</p>
                    <p>
                      <b>
                        {{ $t("organisation.overview.createNewEvent") }}
                        <a href="#" @click="createDialog = !createDialog">{{ $t("organisation.overview.createNewEventClick") }}.</a>
                      </b>
                    </p>
                  </div>
                </div>

                <div class="custom-info-card" v-if="currentPaymentMethods.length <= 0">
                  <div class="custom-info-card-icon">
                    <i class="fa fa-exclamation-triangle" alt="" style="color: #FF7511"></i>
                  </div>
                  <div class="custom-info-card-body">
                    <h6>{{ $t("organisation.overview.creditCardAttention") }}</h6>
                    <p>{{ $t("organisation.overview.creditCardAttentionMsg") }}</p>
                    <p>
                      <b>
                        {{ $t("organisation.overview.addcreditCard") }}
                        <a href="#" @click="$router.push({ name: 'billing' })">{{ $t("organisation.overview.addcreditCardClick") }}.</a>
                      </b>
                    </p>
                  </div>
                </div>

                <div class="custom-info-card" v-if="currentPaymentMethods.some(x => x.errorCount > 0)">
                  <div class="custom-info-card-icon">
                    <i class="fa fa-exclamation-triangle" alt="" style="color: #FF7511"></i>
                  </div>
                  <div class="custom-info-card-body">
                    <h6>{{ $t("organisation.overview.notConnectCreditCardAttention") }}</h6>
                    <p>{{ $t("organisation.overview.notConnectCreditCardAttentionMsg") }}</p>
                    <p>
                      <b>
                        {{ $t("organisation.overview.notConnectAddcreditCard") }}
                        <a href="#" @click="$router.push({ name: 'billing' })">{{ $t("organisation.overview.notConnectAddcreditCardClick") }}.</a>
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="card whitelabel-card" v-if="overviewInfo.whitelabel">
              <div class="card-header header-elements-inline" style="padding-bottom:0px;">
                <h5 class="card-title">{{ $t("organisation.overview.whiteLabel") }}</h5>
                <p class="card-desc" :class="{ 'text-danger': $moment(overviewInfo.whitelabelEndDate).diff(overviewInfo.whitelabelStartDate) < 0 ? true : false }">
                  {{ $t("organisation.overview.whiteLabelStatus") }} : {{ $moment(overviewInfo.whitelabelStartDate).format("DD MMMM YYYY HH:mm") }} -
                  {{ $moment(overviewInfo.whitelabelEndDate).format("DD MMMM YYYY HH:mm") }}
                </p>
              </div>

              <div class="card-body">
                <div class="service-item" v-for="(item, index) in overviewInfo.whitelabelItems" :key="index">
                  <div class="service-icon">
                    <i :class="item.iconClass"></i>
                  </div>
                  <div class="service-desc">
                    <h6>{{ item.title }}</h6>
                    <p>{{ item.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="card plan-card">
              <div class="card-header header-elements-inline" v-if="overviewInfo.currentPlan != null" style="padding-bottom:0px;">
                <div class="plan-badge-container" v-if="overviewInfo.currentPlan.title != null && overviewInfo.subscription.lifetime">
                  <el-badge value="Lifetime" class="plan-badge">
                    <h5 class="card-title">{{ overviewInfo.currentPlan.title }}</h5>
                  </el-badge>
                </div>
                <div class="plan-badge-container" v-else>
                  <h5 class="card-title">{{ overviewInfo.currentPlan.title }}</h5>
                  <div v-html="$t('organisation.overview.planPayment', [overviewInfo.currentPlan.price])"></div>
                </div>
                <div class="header-elements">
                  <el-button-group>
                    <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                      <el-button round icon="fas fa-redo-alt" :loading="loading == 'refresh'" size="mini" @click="refresh()"></el-button>
                    </el-tooltip>
                  </el-button-group>
                </div>
              </div>

              <div class="card-body overview-plan">
                <div class="list-currentplans-usage" v-if="currentOrganization.usage">
                  <div class="usage-item">
                    <span class="usage-title">
                      <span>{{ $t("organisation.overview.events") }}</span>
                      <span class="sub">{{ $t("organisation.overview.unlimited") }}</span>
                    </span>
                    <span class="usage-count"><b style="font-size:32px">∞</b></span>
                  </div>
                  <div class="usage-item" v-if="currentOrganization.usage.registration > 0">
                    <span class="usage-title">
                      <span>{{ $t("organisation.overview.participant") }}</span>
                      <span class="sub" v-if="currentOrganization.usage.registration > 0">%{{ ((currentOrganization.usage.registrationUsage * 100) / currentOrganization.usage.registration).toFixed(2) }} {{ $t("organisation.overview.rate") }}</span>
                    </span>
                    <span class="usage-count" :class="{ 'text-danger': currentOrganization.usage.registrationUsage >= currentOrganization.usage.registration }">{{ currentOrganization.usage.registrationUsage }} / {{ currentOrganization.usage.registration }}</span>
                  </div>
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('createNewEvent')"
      :visible.sync="createDialog"
      class="medium"
      center
      modal-append-to-body
      destroy-on-close
      @close="
        title = null;
        validationErrors = [];
      "
    >
      <div id="createevent-dialog" class="custom-modal">
        <div class="modal-body">
          <el-input v-model="title" size="medium" :class="$inputError('title', validationErrors)" :placeholder="$t('enterEventName')"></el-input>
          <span class="error" v-if="$errorMessage('title', validationErrors)">{{ $errorMessage("title", validationErrors) }}</span>
        </div>
        <div class="modal-footer" slot="footer">
          <div class="left-buttons">
            <el-button @click="createDialog = false">{{ $t("organisation.overview.cancel") }}</el-button>
          </div>
          <div class="right-buttons">
            <el-button type="primary" :disabled="loading" :loading="loading" @click="createEvent">{{ $t("organisation.overview.create") }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "OrganisationOverview",
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.organisationOverview")
    };
  },
  data() {
    return {
      createDialog: false,
      hideunavailables: false,
      loading: false,
      title: null,
      timeout: null,
      validationErrors: []
    };
  },

  computed: {
    currentOrganization() {
      return this.$store.getters.getCurrentOrganization;
    },
    currentPaymentMethods() {
      return this.$store.getters.getPaymentMethods;
    },
    overviewInfo() {
      return this.$store.getters.getSubscriptionOverview;
    }
  },

  async created() {
    await Promise.all([this.$store.dispatch("getOrganization"), this.$store.dispatch("getSubscriptionOverview"), this.$store.dispatch("getPaymentMethods")]);
  },

  watch: {},

  methods: {
    async refresh() {
      this.loading = "refresh";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await Promise.all([this.$store.dispatch("getOrganization"), this.$store.dispatch("getSubscriptionOverview"), this.$store.dispatch("getPaymentMethods")]);
        this.loading = false;
      }, 500);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.status == false && this.hideunavailables == false) {
        return "row-notavailable";
      }
      return "row-available";
    },
    async switchEvent(id) {
      this.eventWrapperLoading(true);
      if ((this.timeout = null)) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("login/switchevent", { id });
        axios.defaults.headers["Authorization"] = "Bearer " + res.data.data.token;
        this.$store.state.user.token = res.data.data.token;
        localStorage.setItem("token", res.data.data.token);
        await this.$store.dispatch("getEvent");
        // await this.$store.dispatch("getPackets");
        await this.$store.dispatch("getSubEvents");
        await this.$store.dispatch("getGroups");
        await this.$store.dispatch("getTags");
        this.$router.push({ name: "event", params: { event_id: id } });
        this.eventWrapperLoading(false);
      }, 500);
    },
    async createEvent() {
      this.loading = true;
      var res = await this.$store.dispatch("createOrganizationEvent", this.title);
      this.validationErrors = res.data.validationErrors;
      if (res.data.alert.hasError) {
        this.$message.error(res.data.alert.message);
      } else {
        this.$message.success(res.data.alert.message);
        await this.$store.dispatch("getOrganizationList");
        await this.$store.dispatch("getAuthorizedEvents");
        this.createDialog = false;
        this.switchEvent(res.data.data.id);
      }

      this.loading = false;
    }
  }
};
</script>

<style lang="less">
#organisation-overview {
  .whitelabel-card {
    .card-header {
      flex-direction: column;
      align-items: flex-start;

      .card-desc {
        flex: 1 1 auto;
        padding: 0;
        font-size: 0.8125rem;
        font-weight: 400;
        line-height: 1.5385;
        color: #333;
        text-align: left;
      }
    }

    .card-body {
      .service-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        widows: 100%;
        padding: 12px 14px;
        background-color: #fbfbfb;
        border-radius: 8px;
        border: 0.5px solid #d6d9d9;
        margin-bottom: 16px;

        .service-icon {
          background: white;
          display: inline-flex;
          width: 60px;
          height: 60px;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          border: 5px solid #d6d9d9;
          border-radius: 12px;

          i {
            color: #268ea6;
            font-size: 24px;
            text-align: center;
          }
        }

        .service-desc {
          width: fit-content;
          margin-left: 20px;

          h6 {
            font-weight: 500;
            color: #292f3b;
            font-size: 16px;
            margin-bottom: 0px;
          }

          p {
            margin-bottom: 0px;
          }
        }
      }
    }
  }

  .overview-card {
    .card-header {
      .header-elements {
        .create-event-button {
          background-color: #268ea6;
          color: white;
          border-color: #268ea6;
        }
      }
    }

    .organisation-header {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 18px 1px;

      .organisation-image {
        width: 80px;
        height: 80px;
        background-color: white;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        border-radius: 16px;
        border: 5px solid #efefef;
      }
      .organisation-title {
        margin-left: 12px;

        span {
          display: block;
          color: #505763;
          font-size: 14px;
          font-weight: 400;
          margin: 0px;
        }

        p {
          color: #292f3b;
          font-size: 18px;
          font-weight: 600;
          margin: 0px;
        }
      }
    }
  }

  .plan-card {
    .card-header {
      .header-elements {
        .upgrade-button {
          background-color: #268ea6;
          color: white;
          border-color: #268ea6;
        }
      }

      .card-title {
        font-size: 18px;
        color: #292f3b;
        font-weight: 600;
        line-height: 20px;

        span {
          display: block;
          font-size: 14px;
          color: #505763;
          font-weight: 500;
        }

        b {
          display: block;
          font-size: 14px;
          color: #8c929c;
          font-weight: 500;
        }
      }
    }

    .card-body {
      .row-notavailable {
        display: none;
      }

      &.overview-plan {
        .list-currentplans-usage {
          display: flex;
          flex-direction: column;
          gap: 10px;
          .usage-item {
            .usage-title {
              display: flex;
              flex-direction: column;
              span {
                font-size: 14px;
                font-weight: bold;
                color: #505763;
              }
              span.sub {
                font-size: 14px;
                font-weight: 400;
                color: #8c929c;
              }
            }
            .usage-count {
              font-weight: bold;
            }
            padding: 1rem 1rem 1rem 0rem;
            border-bottom: 1px solid #ccc;
            align-items: center;
            display: flex;
            flex-direction: row;

            justify-content: space-between;
          }
        }
        .el-table__header-wrapper {
          display: none;
        }

        .btn-hideunavailables {
          background: none;
          border: none;
          font-size: 14px;
          font-weight: 500;
          color: #03658c;
          text-decoration: underline;
          margin: 16px 0px 8px 0px;
          text-align: right;
          width: 100%;
        }

        .op-option {
          font-size: 14px;
          font-weight: 500;
          color: #505763;
          display: block;
        }

        .op-desc {
          font-size: 13px;
          font-weight: 400;
          color: #8c929c;
          display: block;
        }

        .op-total {
          font-size: 14px;
          font-weight: 500;
          color: #505763;

          b {
            font-size: 16px;
            font-weight: 600;
            color: #292f3b;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrganisationOverview.vue